"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpBtnInfo = void 0;
const gs = require("@ivanlog/gs");
const tmpls_1 = require("./tmpls");
class CmpBtnInfo extends tmpls_1.CmpBtnInfoBase {
    constructor() {
        super();
        this._clickHandler = (e) => {
            gs.events.stop(e);
            this._close();
        };
        this.ctrls.btn.onclick = (e) => {
            if (CmpBtnInfo._ActiveBtn)
                CmpBtnInfo._ActiveBtn._close();
            gs.events.stop(e);
            document.addEventListener('click', this._clickHandler);
            this.ctrls.lText.show();
            CmpBtnInfo._ActiveBtn = this;
            const rect = this.ctrls.lText.el.getBoundingClientRect();
            const isOverflowingRight = rect.right > window.innerWidth;
            if (isOverflowingRight)
                this.ctrls.lText.addClass('left');
            else if (rect.left < 0)
                this.ctrls.lText.removeClass('left');
        };
    }
    _close() {
        document.removeEventListener('click', this._clickHandler);
        this.ctrls.lText.hide();
        if (CmpBtnInfo._ActiveBtn == this)
            CmpBtnInfo._ActiveBtn = undefined;
    }
}
exports.CmpBtnInfo = CmpBtnInfo;
//# sourceMappingURL=CmpBtnInfo.js.map